import { FC, useContext, useState, useCallback } from "react";
import { observer } from "mobx-react-lite";
import BtnAdd from "../buttons/btnAdd.component/BtnAdd";
import AddEditProject from "../Shared/AddEditProject/AddEditProject";
import { AppContext } from "../../App";

interface ProjectsToolbarProps {
    loadData: () => Promise<void>;
    addProject?: boolean;
}

const ProjectsToolbar: FC<ProjectsToolbarProps> = observer(({ loadData, addProject }) => {
    const { showToast, archivedPage } = useContext(AppContext);
    const [openEdit, setOpenEdit] = useState<boolean>(false);

    const handleAddClick = useCallback(() => {
        if (addProject) {
            setOpenEdit(true);
        } else {
            showToast("У вас нет прав на добавление проекта!");
        }
    }, [addProject, showToast]);

    const handleCloseModal = useCallback(() => {
        setOpenEdit(false);
    }, []);

    const handleActionComplete = useCallback(async () => {
        await loadData();
        setOpenEdit(false);
    }, [loadData]);

    if (archivedPage) {
        return <div></div>;
    }

    return (
        <div>
            <BtnAdd
                onClickFunc={handleAddClick}
                type=""
                permission={addProject}
            />
            {openEdit && (
                <AddEditProject
                    setOpen={handleCloseModal}
                    onAction={handleActionComplete}
                />
            )}
        </div>
    );
});

export default ProjectsToolbar;